import script from "./CriteriaListPane.vue?vue&type=script&setup=true&lang=js"
export * from "./CriteriaListPane.vue?vue&type=script&setup=true&lang=js"

import "./CriteriaListPane.vue?vue&type=style&index=0&id=5c8aaa44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c8aaa44"]])

export default __exports__